module.exports = __webpack_public_path__ + "img/lxwm_mobile_card.8876c2fa.png";